<template>
  <div class="xslt-template w-full h-full" :class="{ haspdf: hasPdf}">
    <div class="loader" v-if="isGeneralLoading">
      <loading :opacity="0" :active.sync="isGeneralLoading" color="var(--primary-DEFAULT)"></loading>
    </div>
    <detail-layout-two-columns v-if="hasModuleCustomXslt" class="h-full">
      <template slot="LeftCol">
        <base-header style="padding-left: 0px" icon="user" :content="header" />
        <div class="form-wrapper w-full">
          <el-form :model="form" :rules="rules" ref="ruleForm">
            <div class="lg:mb-2">
              <el-form-item prop="idPlantilla">
                <base-el-select ref="templates" class="w-full" :options="baseTemplates" v-model="form.idPlantilla" :exclude-falsys="['']"
                  :option-value="optionValue" :clearable="clearable" filterable :loading="isGeneralLoading" :append-disabled="!selected"
                  @input="onBaseTemplateInput" @append-click="toggleHtml">
                  <template #append>
                    <base-icon :name="showHtml ? 'eye' : 'eyeslash'" />
                  </template>
                </base-el-select>
              </el-form-item>
            </div>
            <div class="lg:mb-2 flex">
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('plantilla_pdf.registration_data_location') }}</label>
                <el-switch class="switch-text break-normal both-switch" 
                    v-model="form.textoIzq" 
                    :active-text="$t('plantilla_pdf.left_margin')" 
                    :inactive-text="$t('plantilla_pdf.page_footer')"
                    inactive-color="var(--primary-800)"
                    :disabled="!selected" />
              </div>
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('plantilla_pdf.languaje_for_foreings') }}</label>
                <el-switch class="switch-text break-normal both-switch" 
                    v-model="form.TraducirParaExtranjeros" 
                    :active-text="$t('langs.en')" 
                    :inactive-text="$t('langs.es')"
                    inactive-color="var(--primary-800)"
                    :disabled="!selected" />
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="flex items-center">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('plantilla_pdf.logo_custom')}}</label>
                <base-tooltip-icon size="sm" :content="tooltipContentLogo" class="ml-2"/>
              </div>
              <div>
                <div class="flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2 mb-2 lg:mb-0">
                    <el-form-item prop="fileLogo" ref="uploadlogo">
                      <Upload
                        ref="upload"
                        id="pfxselector"
                        class="bg-white dark:bg-darkblue-900"
                        :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                        drag
                        action="#"
                        accept="image/png"
                        :limit=1
                        :multiple="false"
                        :disabled="!selected"
                        :auto-upload=false
                        :on-remove="handleRemoveLogo"
                        :on-change="handleChangeLogo">
                        <i class="el-icon-upload"></i>
                        <p v-if="fileLogo.name" class="el-upload__text"><em>{{fileLogo.name}}</em></p>
                        <div v-else class="el-upload__text" v-html="$tc('app.upload_default_no_file_text', 1)"></div>
                      </Upload>
                    </el-form-item>
                    <div class="">
                      <div v-if="fileLogo.b64" class="flex flex-col pb-10 ">
                        <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">{{$t('plantilla_pdf.logo_custom_previsualizacion')}}</label>
                        <div class="flex items-center gap-x-2">
                          <img 
                            id="logo-custom-client-light" 
                            ref="logo-custom-client-light" 
                            :src="`data:image/${getExtensionFromFile(fileLogo.name)};base64, ${fileLogo.b64}`" 
                            :alt="$t('plantilla_pdf.logo_custom')" 
                            class="w-[300px] h-[74px] border-2 border-solid border-primary-300 dark:bg-white rounded object-scale-down object-left"/>
                          <base-button-icon 
                            v-if="hasLogoSaved" 
                            name="cross" 
                            size="xs" 
                            iconSize="xs" 
                            mode="primary-phantom"
                            :disabled="!selected"
                            @click="handleRemoveLogo"/>
                        </div>
                      </div>
                      <div v-else class="flex flex-col pb-10 ">
                        <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">{{$t('personalization.empty_logo_info_msg')}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </template>
      <template slot="RightCol">
        <div v-show="selected && showHtml" :class="{ 'h-screen': hasPdf }"
          class="bg-primary-50 dark:bg-darkblue-800 dark:text-darkblue-200 xl:inline-block relative w-full flex-grow hideHScroll lg:h-full divide-y-2 divide-blue-200 dark:divide-gray-800">
          <PDFViewerApp v-show="hasPdf" :search="actualFilterContent"
            @pdfViewerOpenHandler="pdfViewerOpenHandler" :pdf="pdfUrl" :name="pdfName" />
          <div v-if="!hasPdf" class="w-full h-full p-2 flex flex-col">
            <div v-if="!isGeneralLoading" class="lg:mb-2 lg:mt-2 text-center">{{$t('plantilla_pdf.final_pdf_may_differ_advice')}}</div>
            <iframe id="container-xhtml-iframe" class="transformed-result"></iframe>
          </div>
        </div>
      </template>
      <template slot="layout-extend">
        <base-footer>
          <template slot="actions">
            <base-button-responsive mode="secondary" :text="isFromDistributor ? $t('app.cancel') : $t('app.back')" icon="cross"
              @click="goBack" :loading="isGeneralLoading" />
            <base-button-responsive mode="primary" :text="$t('app.save')" icon="check" @click="submitForm('ruleForm')"
              :loading="isGeneralLoading" :disabled="isGeneralLoading" />
          </template>
        </base-footer>
      </template>
    </detail-layout-two-columns>
    <detail-layout-full-width v-else class="h-full">
      <template slot="header">
        <base-header icon="user" :content="header" />
      </template>
      <template slot="main">
        <div class="dark:text-white">{{ $t('feedback.error.absent_module_error') }}</div>
      </template>
      <template slot="layout-extend">
        <base-footer>
          <template slot="actions">
          </template>
        </base-footer>
      </template>
    </detail-layout-full-width>
  </div>
</template>

<script>
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import DetailLayoutTwoColumns from '@/components/layout/DetailLayoutTwoColumns.vue'
import PDFViewerApp from '@/components/pdf/PDFViewerApp.vue'
import Loading from 'vue-loading-overlay'
import { Upload } from 'element-ui'

import { i18n } from '@/i18n'
import { getDistributor } from '@/services/distributors/getDistributor'
import { genericGETFile } from '@/services/genericGETFile'
import { getPlantillasImagenDistribuidor } from '@/services/distributors/getPlantillasImagenDistribuidor'
import { getPlantillaContentDistribuidor } from '@/services/distributors/getPlantillaContentDistribuidor'
import { updatePlantillaXsltDistribuidor } from '@/services/distributors/updatePlantillaXsltDistribuidor'
import { bus } from '@/main'

export default {
  name: 'template-client-xslt-detail',
  components: {
    DetailLayoutFullWidth,
    DetailLayoutTwoColumns,
    Upload,
    PDFViewerApp,
    Loading,
  },
  data () {
    return {
      activeName: 'es',
      tooltipContentLogo: i18n.t('tooltip.logo_png'),
      header: {
        title: i18n.t('plantilla_pdf.header_long'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: this.isFromDistributor ? 'configurations/distributors/details' : 'configurations/distributors'
      },
      form: {
        idPlantilla: '',
        textoIzq: false,
        TraducirParaExtranjeros: false
      },
      maxSizefile: 1048576, // Bytes (1MB)
      fileLogo: {
        name: '',
        b64: '',
        bytes: null,
      },
      rules: {
        idPlantilla: [
          {
            required: false,
            message: i18n.t('validation.complete'),
            trigger: ['blur', 'change']
          },
        ],
        fileLogo: [
          {
            message: i18n.t('validation.not_single_valid_extension', { ext: '.png' }),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileLogo.name && (this.fileLogo.name.length < 3 || this.getExtensionFromFile(this.fileLogo.name).toUpperCase() !== 'PNG')) {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: '.png' })))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.logo_width_height'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileLogo.name &&
                (this.$refs['logo-custom-client-light'].naturalHeight !== 74 || this.$refs['logo-custom-client-light'].naturalWidth !== 300)) {
                callback(new Error(i18n.t('validation.logo_width_height')))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.exceed_size_files') + ' (1 MB)',
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileLogo.name && this.fileLogo.bytes && 
                this.fileLogo.bytes.size > this.maxSizeFile) {
                callback(new Error(i18n.t('validation.exceed_size_files')))
              } else {
                callback()
              }
            }
          },
        ],
      },


      showHtml: false,
      generatedHtml: '',
      lasttemplate: null,
      lastpdf: {
        name: '',
        url: ''
      },
      baseTemplates: [],
      inheritTemplate: null,
      exampleXml: '',
      defaultHtml: i18n.t('plantilla_pdf.xslt_not_valid'),
      actualFilterContent: null,
      haseditor: false,
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    fileLogo: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.textoIzq' (value) {
      if (this.showHtml) {
        this.changePDF()
      }
    },
    showHtml (newValue) {
      if (newValue) {
        this.changePDF()
        this.lastpdf.name = this.selected.Nombre
        this.lastpdf.url = this.b64Pdf ? `data:application/pdf;base64,${this.b64Pdf}` : ''
      }
    },
    generatedHtml (value, oldValue) {
      this.insertIframeContent()
    }
  },
  computed: {
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id () {
      return this.$route.params.id ? this.$route.params.id : -1
    },
    isFromDistributor () {
      return this.id !== -1
    },
    hasModuleCustomXslt () {
      return this.$store.getters['auth/hasXsltModule']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasPdf: function () {
      return !!((!this.form.textoIzq && this.selected?.PdfEjemplo) || (this.form.textoIzq && this.selected?.PdfEjemploIzq))
    },
    b64Pdf: function () {
      return this.form.textoIzq ? this.selected?.PdfEjemploIzq : this.selected?.PdfEjemplo
    },
    pdfUrl: function () {
      return (this.b64Pdf && this.showHtml ? `data:application/pdf;base64,${this.b64Pdf}` : this.lastpdf.url) || ''
    },
    pdfName: function () {
      return this.selected?.Nombre || this.lastpdf.name || ''
    },
    hasLogoSaved () {
      return this.fileLogo && this.fileLogo.b64 && !this.fileLogo.bytes
    },
    clearable () {
      return this.form.idPlantilla !== this.inheritTemplate?.idPlantilla
    },
    selected () {
      return this.baseTemplates.find(x => (x.idPlantilla || '') === this.form.idPlantilla)
    }
  },
  created: async function () {
    const breadcrumbs = []

    if (this.isFromDistributor) {
      breadcrumbs.push({
        path: 'configurationssa',
        name: i18n.t('configurations.header')
      })
      breadcrumbs.push({
        path: 'configurations/distributors',
        name: i18n.t('distributors.header')
      })
      const distributor = await this.downloadDistributorData(this.id)
      breadcrumbs.push({ path: '', name: distributor.distribuidor.Nombre })
      this.$store.commit('app/setheaderBreadCrumb', distributor.distribuidor.Nombre)
      this.disableRoutes(distributor.distribuidor.idTipoProvisionamiento)
    }

    this.header.breadcrumb = breadcrumbs

    if (this.hasModuleCustomXslt) {
      try {
        this.$store.commit('setIsLoading', true)
        const dataXslt = await this.downloadDataXslt(this.isFromDistributor ? this.id : null)
        this.setDataXslt(dataXslt?.Respuesta)
        if (this.showHtml) {
          this.generateHtmlFromXslt()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    }
  },
  mounted () {
    this.header.url = this.isFromDistributor ? 'configurations/distributors/details' : 'configurations'
  },
  methods: {
    disableRoutes: function (idTipoProvisionamiento) {
      const objDisableRoutes = {
        disableModules: idTipoProvisionamiento === 1,
        disableLocations: idTipoProvisionamiento === 1,
      }
      bus.$emit('disableOptionsDistributor', objDisableRoutes)
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
      if (this.selected && this.showHtml) {
        this.lastpdf.name = this.selected.Nombre
        this.lastpdf.url = this.b64Pdf ? `data:application/pdf;base64,${this.b64Pdf}` : ''
      }
    },
    handleChangeLogo: function (fileLogo) {
      this.$refs.uploadlogo.clearValidate()
      this.fileLogo.name = fileLogo.name
      this.getBase64(fileLogo.raw).then(res => {
        const b64 = res.split(',')
        this.fileLogo.b64 = b64[1]
      })
      this.fileLogo.bytes = fileLogo
    },
    handleRemoveLogo: function () {
      this.fileLogo.name = null
      this.fileLogo.b64 = null
      this.fileLogo.bytes = null
    },
    downloadDistributorData: async function (id) {
      let distributor = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idDistribuidor: id
        }
        const response = await getDistributor(params)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        }
        distributor = response.distribuidor
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return distributor
    },
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            idDistribuidor: this.isFromDistributor ? this.id : null,
            idPlantilla: this.form.idPlantilla,
            TextoIzq: !!this.form.textoIzq,
            TraducirParaExtranjeros: !!this.form.TraducirParaExtranjeros,
            Logo: this.fileLogo && this.fileLogo.b64 && this.fileLogo.name
              ? {
                Contenido: this.fileLogo.b64,
                Extension: this.getExtensionFromFile(this.fileLogo.name)
              } 
              : null,
          }
          const response = await updatePlantillaXsltDistribuidor(params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      if (this.role === 2) {
        this.$router.push({ name: 'configurations' })
      } else {
        if (this.isFromDistributor) this.$router.push({ name: 'configurations/distributors/details', params: this.id })
        else this.$router.push({ name: 'configurations/distributors' })
      }
    },
    downloadDataXslt: async function (id) {
      try {
        const template = await getPlantillasImagenDistribuidor({ idDistribuidor: id })
        if (template.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', template))
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      }
      return null
    },
    setDataXslt: function (data) {
      if (data) {
        this.baseTemplates = data.templates || []
        if (data.inherit) {
          this.inheritTemplate = data.inherit
          this.baseTemplates.unshift(data.inherit)
        }
        this.form.idPlantilla = data.config?.PlantillaActiva?.idPlantilla ?? ''
        this.form.textoIzq = !!data.config?.TextoIzq
        this.form.TraducirParaExtranjeros = !!data.config?.TraducirParaExtranjeros
        this.fileLogo.b64 = data.Logo?.Contenido 
        this.fileLogo.name = data.Logo 
          ? 'custom-logo.' + data.Logo?.Extension 
          : null
        if (this.selected) {
          this.$nextTick(() => { this.showHtml = true })
        }
      } else {
        this.baseTemplates = []
      }
    },
    toggleHtml: function () {
      this.showHtml = !this.showHtml
    },
    async generateHtmlFromXslt () {
      if (!this.hasPdf) {
        if (this.selected && this.lasttemplate?.Contenido !== this.selected?.Contenido) {
          try {
            this.$store.commit('setIsLoading', true)
            this.lasttemplate = JSON.parse(JSON.stringify(this.selected))
            const xslt = this.selected?.Contenido
    
            const parser = new DOMParser()
            const xsltDoc = parser.parseFromString((xslt || ''), 'application/xml')
            if (!this.exampleXml) {
              const response = await genericGETFile('/api/personalizacion/getxmlejemplo')
              this.exampleXml = await response.data.text()
            }
            const xmlDoc = parser.parseFromString(this.exampleXml, 'application/xml')
    
            const xsltProcessor = new XSLTProcessor()
            xsltProcessor.importStylesheet(xsltDoc)
            let resultDoc = xsltProcessor.transformToDocument(xmlDoc)
    
            if (!resultDoc) {
              resultDoc = parser.parseFromString(this.defaultHtml, 'text/html')
            }
    
            const serializer = new XMLSerializer()
            let transformedHtml = serializer.serializeToString(resultDoc)
    
            transformedHtml = transformedHtml.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
            transformedHtml = transformedHtml.replace(/<script\b[^<]*\/>/gi, '')
            transformedHtml = transformedHtml.replace(/<[^>]*\bon[^=]*=[^>]*>/gi, '')
    
            this.generatedHtml = transformedHtml
          } finally {
            this.$store.commit('setIsLoading', false)
          }
        } else {
          this.$nextTick(() => this.insertIframeContent())
        }
      }
    },
    insertIframeContent () {
      try {
        this.$store.commit('setIsLoading', true)
        let iframe = document.getElementById('container-xhtml-iframe')
  
        if (iframe) {
          iframe.addEventListener('load', () => {
            const doc = iframe?.contentDocument || iframe?.document || iframe
            const style = doc.createElement('style')
            style.textContent = this.getScrollBarsStyle()
            style.textContent += '.page { padding: 15mm; } @media not print { html { max-height: 100%; } body { width: 210mm; height: 297mm; overflow-x: hidden; } body { transform-origin: top left; transform: scale(calc(100vw / 210mm)); } }'
            if (!doc.head) {
              const head = doc.createElement('head')
              head.appendChild(style)
              doc.appendChild(head)
            } else {
              doc.head.appendChild(style) 
            }
          })
          iframe = iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument)
    
          iframe.document.open()
          iframe.document.write(this.generatedHtml)
          iframe.document.close()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    getScrollBarsStyle: function () {
      const computedStyle = getComputedStyle(document.documentElement)
      const variableNames = ['--primary-400', '--primary-500', '--Component-background-']
      const rootStyle = variableNames.map(x => `${x}: ${computedStyle.getPropertyValue(x)}`).join('; ')
      return `:root { ${rootStyle} } ::-webkit-scrollbar { width: 8px; height: 8px; } ::-webkit-scrollbar-track { background-color: transparent; } ::-webkit-scrollbar-thumb { background-color: var(--primary-400); border-radius: 20px; } ::-webkit-scrollbar-corner { background: var(--Component-background-); } ::-webkit-scrollbar-thumb:hover { background: var(--primary-500); } ::-webkit-scrollbar-button { height: 2px; width: 2px; }`
    },
    optionValue (option) {
      return option.idPlantilla || ''
    },
    onBaseTemplateInput (value) {
      if (this.showHtml) {
        this.changePDF()
      }
    },
    pdfViewerOpenHandler () {
      this.actualFilterContent = null
    },
    async changePDF () {
      if (!this.selected.Contenido) {
        const content = await this.downloadXsltContent()
        if (!content) {
          return
        }
        Object.keys(content).forEach(key => this.$set(this.selected, key, content[key]))
      }
      if (this.form.textoIzq) {
        if (!this.selected.PdfEjemploIzq) {
          this.generateHtmlFromXslt()
        }
      } else {
        if (!this.selected.PdfEjemplo) {
          this.generateHtmlFromXslt()
        }
      }
    },
    async downloadXsltContent () {
      try {
        this.$store.commit('setIsLoading', true)
        const idPlantilla = this.form.idPlantilla || this.selected.idPlantillaHeredada
        const response = await getPlantillaContentDistribuidor({ idPlantilla, idDistribuidor: this.isFromDistributor ? this.id : null })
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          return response?.Respuesta
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    }
  }
}
</script>

<style scoped>
.transformed-result {
  background-color: var(--secondary-100) !important;
  border-bottom-left-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
  margin-top: 5px;
  margin-inline: auto;
  width: 100%;
  height: 100%;
  max-height: 297mm;
  max-width: 210mm;
  box-sizing: border-box;
}
@media (min-width: 1024px) {
  .xslt-template.haspdf .layout-detail-two-columns::v-deep > main {
    overflow-y: hidden;
  }
}

#pfxselector:has(.is-disabled)::v-deep * {
 cursor: not-allowed;
}

.hideHScroll {
  overflow-x: hidden;
}
</style>
